import { render, staticRenderFns } from "./OrderDataManage.vue?vue&type=template&id=1371489b&scoped=true"
import script from "./OrderDataManage.vue?vue&type=script&lang=js"
export * from "./OrderDataManage.vue?vue&type=script&lang=js"
import style0 from "./OrderDataManage.vue?vue&type=style&index=0&id=1371489b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1371489b",
  null
  
)

export default component.exports